export default __webpack_public_path__ + "static/PC_bg_03-5c7e4bd8cb35e8c8446a8bfdedf1de56.png";